// Recovered compiled webpack factory 64425. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      ROOT_SEGMENT_CACHE_KEY: function () {
        return o;
      },
      ROOT_SEGMENT_REQUEST_KEY: function () {
        return a;
      },
      appendSegmentCacheKeyPart: function () {
        return u;
      },
      appendSegmentRequestKeyPart: function () {
        return s;
      },
      convertSegmentPathToStaticExportFilename: function () {
        return d;
      },
      createSegmentCacheKeyPart: function () {
        return l;
      },
      createSegmentRequestKeyPart: function () {
        return i;
      },
    }));
  let n = r(65360),
    a = "",
    o = "";
  function i(e) {
    if ("string" == typeof e)
      return e.startsWith(n.PAGE_SEGMENT_KEY)
        ? n.PAGE_SEGMENT_KEY
        : "/_not-found" === e
          ? "_not-found"
          : f(e);
    let t = e[0],
      r = e[2];
    return "$" + r + "$" + f(t);
  }
  function s(e, t, r) {
    return e + "/" + ("children" === t ? r : "@" + f(t) + "/" + r);
  }
  function l(e, t) {
    return "string" == typeof t ? e : e + "$" + f(t[1]);
  }
  function u(e, t, r) {
    return e + "/" + ("children" === t ? r : "@" + f(t) + "/" + r);
  }
  let c = /^[a-zA-Z0-9\-_@]+$/;
  function f(e) {
    return c.test(e) ? e : "!" + btoa(e).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }
  function d(e) {
    return "__next" + e.replace(/\//g, ".") + ".txt";
  }
}
